import React from "react";
import ModelSubmitWorkForm from "./ModelSubmitWorkForm";
import { ModalHeader } from "reactstrap";
import CloudStorage from "../../../../../../../../CloudStorage/CloudStorage";

export default function ProjectSubmitwork({
  milestonedata,
  setASModel,
  index,
}) {
  return (
    <>
      <button onClick={() => setASModel(false)} className="btn close-button">
        <img
          src={`${CloudStorage.cloudurl}//Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <div className="modal-body pb-0">
        <p>Submit work for payment </p>

        <h4>
          Milestone {index} : {milestonedata?.title}
        </h4>

        {Array.isArray(milestonedata.submition) &&
          milestonedata.submition[0]?.revision && (
            <div >
              <p>Last Revision Details</p>
              <h4>{milestonedata.submition[0]?.revision}</h4>
            </div>
          )}
        <ModelSubmitWorkForm setASModel={setASModel} milestonedata={milestonedata} />
      </div>
    </>
  );
}
